/** 与 Main / Shop 商品卡一致：标题、规格行、最低价（用于「From €…」） */

export function pickProductTitle(it, langSuffix) {
  const localized =
    it?.[`name_${langSuffix}`] ??
    it?.[`title_${langSuffix}`] ??
    (langSuffix === "nl"
      ? it?.name_uk ?? it?.title_uk
      : it?.name_nl ?? it?.title_nl);
  const fallback = it?.title ?? it?.name ?? it?.product_name;
  const v = localized ?? fallback;
  return v != null && String(v).trim() !== "" ? String(v).trim() : "Unnamed";
}

function normAttrStr(s) {
  return s == null ? "" : String(s).trim();
}

function isConcentratieMgAttrName(raw) {
  const n = normAttrStr(raw).toLowerCase().replace(/\s+/g, " ");
  if (!n) return false;
  return (
    /^concentratie\s*\(\s*mg\s*\)/.test(n) ||
    /^concentration\s*\(\s*mg\s*\)/.test(n)
  );
}

function isConcentratieMgAttr(a, langSuffix) {
  const names = [
    a?.[`attr_name_${langSuffix}`],
    a?.attr_name_nl,
    a?.attr_name_uk,
    a?.attr_name,
    a?.attrName,
  ];
  return names.some((name) => isConcentratieMgAttrName(name));
}

/** 汇总 Concentratie (mg)，如 500mg · 1000mg */
export function pickDosageLine(it, langSuffix) {
  const skulist = it?.skulist ?? it?.skuList ?? [];
  if (!Array.isArray(skulist) || skulist.length === 0) return "";

  const getAttrs = (sku) =>
    Array.isArray(sku?.attributeslist)
      ? sku.attributeslist
      : Array.isArray(sku?.attributesList)
        ? sku.attributesList
        : [];

  const values = [];
  const seen = new Set();
  for (const sku of skulist) {
    const attrs = getAttrs(sku);
    for (const a of attrs) {
      if (!isConcentratieMgAttr(a, langSuffix)) continue;
      const v = normAttrStr(
        a?.[`attr_value_${langSuffix}`] ?? a?.attr_value ?? a?.attrValue ?? ""
      );
      if (!v) continue;
      const key = v.toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        values.push(v);
      }
    }
  }

  return values.length ? values.join(" · ") : "";
}

/** 用于卡片「From €…」的最低欧元价 */
export function pickMinPriceNumber(it, langSuffix) {
  const skus = it?.skulist ?? it?.skuList ?? [];
  const nums = [];
  if (Array.isArray(skus)) {
    for (const s of skus) {
      const n = Number(s?.[`price_${langSuffix}`] ?? s?.price);
      if (!isNaN(n) && n > 0) nums.push(n);
    }
  }
  if (nums.length) return Math.min(...nums);
  const min =
    it?.price_min ?? it?.min_price ?? it?.minPrice ?? it?.lowest_price;
  if (min != null && min !== "") {
    const n = Number(min);
    if (!isNaN(n) && n > 0) return n;
  }
  const single = it?.price ?? it?.sale_price ?? it?.priceNew ?? it?.price_new;
  if (single != null && single !== "") {
    const n = Number(single);
    if (!isNaN(n) && n > 0) return n;
  }
  return null;
}
